import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { TuiCalendarModule } from "@taiga-ui/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { KwikUICalendarComponent } from "./calendar.component";

@NgModule({
  declarations: [KwikUICalendarComponent],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, TuiCalendarModule],
  exports: [KwikUICalendarComponent]
})
export class KwikUICalendarModule {}
